import { useState } from "react";
import { PaginatedAdminToolUsersDto } from "../api/models/AdminToolUserDto";
import { getToolUsers } from "../api/adminToolUserSearchClient";

export const useAdminToolUserSearch = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<PaginatedAdminToolUsersDto>({ items: [], totalCount: 0 });

  const fetchToolUsers = async (
    toolKey: string,
    capabilityId: string,
    page: number,
    pageSize: number
  ) => {
    setIsLoading(true);
    try {
      const result = await getToolUsers(toolKey, capabilityId, page, pageSize);
      setData(result);
    } catch (error) {
      console.error("Failed to fetch tool users", error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    fetchToolUsers,
    isLoading,
    data,
  };
};
